module.exports = __webpack_public_path__ + "static/media/shopware6_certified_developer.c8e6cb43.svg";